



































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import Swiper from '@/components/Swiper';
import { capitalize } from '@/utils';

@Component({
  name: 'CatalogTile',
  components: {
    Swiper,
  },
  props: {
    lock: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
    design: {
      type: String,
      default: '',
    },
    floor: {
      type: Number,
      default: 0,
    },
    rooms: {
      type: Number,
      default: 0,
    },
    area: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    price: {
      type: [Number, String],
      default: 0,
    },
    texts: {
      type: Object,
      default: {},
    },
    reservation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    designCapitalize() {
      return capitalize((this as any).design.toLowerCase());
    },
  },
  data() {
    return {
      swiperOption: {
        lock: (this as any).lock,
        draggable: false,
        linkTo: this.$router.resolve({
          name: 'reservation',
          params: {
            id: this.id,
            design: capitalize((this as any).design.toLowerCase()),
            rooms: (this as any).rooms,
          },
        }).href,
        height: 220,
        loop: true,
        navigation: {
          class: 'nav-icon',
        },
        pagination: false,
        mobile: true,
      },
    };
  },
  methods: {
    goToReservation(e) {
      e.target.disabled = true;
      this.$router.push(
          {
            name: 'reservation',
            params: {
              id: (this as any).id,
              design: (this as any).designCapitalize,
              rooms: (this as any).rooms,
            },
          });
    },
  },
})
export default class CatalogTile extends Vue {
}
